<template>
  <div class="footer-wrapper">
    <footer class="footer-section">
      <div class="container">
        <div class="row mb-3" id="company">
          <p>Let's see our certifications!</p>
          <div class="certifications">
            <a
              v-for="(certification, index) in certifications"
              :key="index"
              :href="certification.link"
              target="_blank"
              rel="noopener noreferrer"
              :title="`${certification.link}`"
            >
              <img
                draggable="false"
                :src="publicPath + certification.image"
                :alt="certification.alt"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div class="top">
          <div class="left">
            <ul class="navigation_links-footer">
              <li v-for="(link, index) in footerLinks" :key="index">
                <a :class="{ active: isActive(link.url) }" :href="link.url">{{
                  link.label
                }}</a>
              </li>
            </ul>
          </div>
          <div class="socials">
            <div class="linkedin mb-4">
              <a
                target="_blank"
                rel="nofollow"
                href="https://www.linkedin.com/company/the-ear-limited/mycompany/"
              >
                <img
                  draggable="false"
                  :src="publicPath + 'assets/images/linkedin.svg'"
                  alt="linkedin"
                  class="mr-3"
                  width="44"
                  height="44"
                  loading="lazy"
                />
                <span>The Ear Platform</span>
              </a>
            </div>
            <div class="linkedin">
              <a
                target="_blank"
                rel="nofollow"
                href="https://www.linkedin.com/company/the-ear-casino/"
              >
                <img
                  draggable="false"
                  :src="publicPath + 'assets/images/linkedin.svg'"
                  alt="linkedin"
                  class="mr-3 margin-mobile"
                  width="44"
                  height="44"
                  loading="lazy"
                />
                <span>The Ear Casino</span>
              </a>
            </div>
          </div>
        </div>
        <div class="company-information">
          <p class="mb-2">
            <b
              >Copyright The New EAR S.r.l.
              <span id="year">{{ new Date().getFullYear() }}</span> All Rights
              Reserved.</b
            >
          </p>
          <p class="text-center company-legal_information">
            The New Ear S.r.l., a company incorporated in Italy, company number
            2552643 with VAT 10719620964,with its Registered Office at 20123
            Milano (MI), Via Della Posta N.8 , Italy
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
      footerLinks: [
        { label: "Home", url: `/${this.lang ?? "en"}/` },
        {
          label: "Games",
          url: `/${this.lang ?? "en"}/games`,
        },
        {
          label: "About Us",
          url: `/${this.lang ?? "en"}/about-us`,
        },
        {
          label: "Carreers",
          url: `/${this.lang ?? "en"}/careers`,
        },
        {
          label: "Our Solutions",
          url: `/${this.lang ?? "en"}/solutions`,
        },
        {
          label: "Contact",
          url: `/${this.lang ?? "en"}/contact`,
        },
        { label: "Cookie", url: `/${this.lang ?? "en"}/cookie` },
      ],
      certifications: [
        {
          image: "assets/images/ONJN.png",
          alt: "ONJN Certification",
          link: "https://onjn.gov.ro/",
        },
        {
          image: "assets/images/ADM_Logo.svg",
          alt: "ADM Certification",
          link: "https://www.adm.gov.it/",
        },
        {
          image: "assets/images/maltaGaming.png",
          alt: "Malta Gaming Certification",
          link: "https://www.mga.org.mt/",
        },
        {
          image: "assets/images/eeep-logo-en.png",
          alt: "Hellenic Gaming Commission",
          link: "https://www.gamingcommission.gov.gr/",
        },
      ],
    };
  },
  created() {
    let lang = localStorage.getItem("language") ?? "en";
    this.lang = lang;
  },
  methods: {
    isActive(url) {
      const currentPath = this.$route.path;
      return url === currentPath;
    },
  },
};
</script>

<style scoped>
.footer-wrapper {
  width: 100%;
  position: relative;
  height: 100%;
}
.footer-section {
  /* background: #1d1028 !important; */
  background: #1c1c1c !important;
  color: #c6c6c6;
  font-size: 1.2rem;
  text-align: center;
  position: relative;
  min-height: 100%;
  width: 100%;
  padding: 25px 0px 15px;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.certifications {
  /* display: flex;
  align-items: center;
  justify-content: center; */
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  place-items: center;
  margin: 10px 0px;
}

.certifications img {
  /* max-width: 150px;
  min-width: 150px;
  object-fit: contain;
  margin: 20px;
  aspect-ratio: 4/3;
  transition: 0.3s all;
  pointer-events: none;
  user-select: none; */
  /* max-width: 150px; */
  /* min-width: 150px; */
  -o-object-fit: contain;
  object-fit: contain;
  /* margin: 20px; */
  aspect-ratio: 4 / 3;
  transition: 0.3s all;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  max-width: 70%;
  height: 100%;
  max-height: 130px;
  width: 100%;
}

.certifications a:hover {
  transform: scale(1.1);
  transition: 0.3s all;
}

.navigation_links-footer {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  white-space: nowrap;
  padding-right: 10px;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 0rem;
  padding-left: 0rem;
}

.navigation_links-footer li {
  margin: 5px;
}

a {
  text-decoration: none;
  color: white;
  font-weight: 600;
  font-size: 15px;
  transition: 0.3s all;
}

a:hover {
  color: cornflowerblue;
  transition: 0.3s all;
}

.company-information {
  font-size: 17px;
  line-height: 1.44rem;
  font-family: "Montserrat", sans-serif;
}

.company-legal_information {
  font-size: 14px;
  line-height: 1.65;
  font-family: "Montserrat", sans-serif;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.col {
  min-width: 250px;
  color: #f2f2f2f2;
  font-family: "Montserrat", sans-serif;
  padding: 0 2rem;
}

.col h3 {
  color: #ff014fff;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
}

.col h3::after {
  content: "";
  height: 3px;
  width: 0px;
  background-color: #ff014fff;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: 0.3s ease;
}

.col h3:hover::after {
  width: 30px;
}

.col .social a i {
  color: #ff014fff;
  margin-top: 2rem;
  margin-right: 5px;
  transition: 0.3s ease;
}

.col .social a i:hover {
  transform: scale(1.5);
  filter: grayscale(25);
}

.col .links a {
  display: block;
  text-decoration: none;
  color: #f2f2f2;
  margin-bottom: 5px;
  position: relative;
  transition: 0.3s ease;
}

.col .links a::before {
  content: "";
  height: 16px;
  width: 3px;
  position: absolute;
  top: 5px;
  left: -10px;
  background-color: #ff014fff;
  transition: 0.5s ease;
  opacity: 0;
}

.col .links a:hover::before {
  opacity: 1;
}

.col .links a:hover {
  transform: translateX(-8px);
  color: #ff014fff;
}

.col .contact-details {
  display: inline-flex;
  justify-content: space-between;
}

.col .contact-details i {
  margin-right: 15px;
}

.row .form {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
}

.row .form input {
  background-color: #110816;
  border: 0;
  outline: none;
  padding: 14px 20px;
  border-radius: 6px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.row > * {
  padding-right: 0px;
  padding-left: 0px;
}

.top {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.top .left {
  /* max-width: 470px;
  width: 100%;
  display: flex;
  align-items: center; */
  max-width: 400px;
  width: 100%;
  display: flex;
  align-items: baseline;
  flex-direction: column;
  flex-wrap: wrap;
}
/* .footer-menu .top .socials {
  display: flex;
  max-width: 460px;
  width: 100%;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
} */

.top .socials {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

@media (max-width: 900px) {
  .row {
    flex-direction: column;
    width: 100%;
  }

  .col {
    width: 100%;
    text-align: left;
    margin-bottom: 25px;
  }

  .top .socials {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .certifications {
    /* display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap; */
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-items: center;
  }

  .certifications img {
    /* min-width: 75px;
    max-width: 75px;
    -o-object-fit: contain;
    object-fit: contain;
    margin: 10px;
    aspect-ratio: 4/3;
    user-select: none;
    pointer-events: none;
    transition: 0.3s all; */
    /* min-width: 100%; */
    /* max-width: 100%; */
    -o-object-fit: contain;
    object-fit: contain;
    margin: 0;
    aspect-ratio: 4 / 3;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    pointer-events: none;
    transition: 0.3s all;
    width: 100%;
    height: 100%;
    max-height: 125px;
    max-width: 70%;
    padding: 10px 8px;
  }
  .row {
    flex-direction: column;
    width: 100%;
  }

  .col {
    width: 100%;
    text-align: left;
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .top .socials {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .margin-mobile {
    margin-left: -10px;
  }

  .linkedin {
    a {
      img {
        max-width: 30px !important;
      }
    }
  }
}

.router-link-active {
  color: cornflowerblue !important;
  font-weight: bold;
}

.active {
  border-bottom: 1px solid cornflowerblue;
  color: cornflowerblue !important ;
  font-weight: 800 !important;
  text-shadow: 0px 0px 5px #0000008f;
}
</style>
